// =======================================================
// oo-cart-fix.js
// =======================================================
// 1) Redirection vers /cart après ajout au panier (sans boucle)
// 2) Désactivation propre du drawer MaxDesign (no-op, pas de redirect)
// 3) Bouton sticky "ALLER AU PANIER" -> /cart#cmd-ui
// 4) Ligne HTVA visible uniquement si TVA validée (OO)
// 5) Ajout des services PC-Occasion cochés avec le PC
// =======================================================

(function () {
  "use strict";

  /* -------------------------------------------------------
   * Helpers
   * ----------------------------------------------------- */

  function getRootUrl() {
    const root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/";
    return root.endsWith("/") ? root : root + "/";
  }

  const ROOT = getRootUrl();
  const CART_URL = ROOT + "cart";
  const CART_ADD_URL = ROOT + "cart/add.js";

  /* -------------------------------------------------------
   * 1) Bouton sticky "ALLER AU PANIER" (drawer)
   * ----------------------------------------------------- */

  function isInMaxdesignDrawer(el) {
    if (!el) return false;
    return Boolean(
      el.closest("modal-maxdesign") ||
        el.closest("#cmd[data-type='modal']") ||
        el.closest("[data-type='modal']") ||
        el.closest(".cmd-modal") ||
        el.closest(".cmd-modal__content")
    );
  }

  document.addEventListener(
    "click",
    function (e) {
      const btn = e.target?.closest?.(
        "button.cmd-btn__sticky, button.cmd-btn--sticky"
      );
      if (!btn) return;
      if (!isInMaxdesignDrawer(btn)) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      window.location.href = CART_URL + "#cmd-ui";
    },
    true
  );

  /* -------------------------------------------------------
   * 2) Patch MaxDesign cart modal (NO-OP, PAS DE REDIRECT)
   * ----------------------------------------------------- */

  (function patchCartModal() {
    let tries = 0;

    const timer = setInterval(() => {
      tries++;

      const cartModal = window.MaxDesign?.modal?.cart;
      if (!cartModal || cartModal.__ooCartPatched) {
        if (tries > 80) clearInterval(timer);
        return;
      }

      cartModal.__ooOriginalOpen = cartModal.open?.bind(cartModal);

      cartModal.open = function () {
        try {
          this.overlay = { state: "close" };
          this.state = "close";
          this.close?.();
        } catch (e) {}
        return;
      };

      cartModal.__ooCartPatched = true;
      clearInterval(timer);
    }, 100);
  })();

  /* -------------------------------------------------------
   * 3) Ajout au panier -> redirect /cart (ANTI BOUCLE)
   *    + services PC-Occasion cochés
   * ----------------------------------------------------- */

  let isAdding = false;

  function buildMainCartItem(form) {
    const fd = new FormData(form);
    const id = fd.get("id");

    if (!id) return null;

    const item = {
      id: Number(id),
      quantity: Math.max(1, Number(fd.get("quantity") || 1))
    };

    const properties = {};

    for (const [key, value] of fd.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);

      if (match && value !== "" && value != null) {
        properties[match[1]] = value;
      }
    }

    if (Object.keys(properties).length) {
      item.properties = properties;
    }

    const sellingPlan = fd.get("selling_plan");
    if (sellingPlan) {
      item.selling_plan = Number(sellingPlan);
    }

    return item;
  }

  function getSelectedServiceItems() {
    return Array.from(
      document.querySelectorAll("[data-pco-services] [data-pcocc-service]:checked")
    )
      .map((input) => Number(input.value))
      .filter(Boolean)
      .map((id) => ({
        id,
        quantity: 1
      }));
  }

  async function addToCartThenRedirect(form) {
    if (isAdding) return;
    isAdding = true;

    try {
      const mainItem = buildMainCartItem(form);

      if (!mainItem) {
        isAdding = false;
        return;
      }

      const items = [mainItem, ...getSelectedServiceItems()];

      const res = await fetch(CART_ADD_URL, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ items })
      });

      if (!res.ok) {
        isAdding = false;
        return;
      }

      window.location.href = CART_URL;
    } catch (e) {
      isAdding = false;
    }
  }

  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target?.closest?.('form[action*="/cart/add"]');
      if (!form) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      addToCartThenRedirect(form);
    },
    true
  );

  /* -------------------------------------------------------
   * 4) TVA OO – affichage HTVA conditionnel
   * ----------------------------------------------------- */

  function isVatValidated() {
    const root = document.querySelector("#oo-tax-exemption");
    if (!root) return false;

    if (
      root.querySelector(
        ".oo-tax-success, .oo-success, .success, [data-status='success']"
      )
    ) {
      return true;
    }

    const txt = (root.textContent || "").toLowerCase();

    const tokens = [
      "validé",
      "validation réussie",
      "validated",
      "validation successful",
      "gevalideerd",
      "succesvol",
      "succes",
      "geldig",
      "goedgekeurd"
    ];

    return tokens.some((t) => txt.includes(t));
  }

  function toggleHtvaLine() {
    const line = document.getElementById("cmd-htva-line");
    if (!line) return;
    line.style.display = isVatValidated() ? "" : "none";
  }

  document.addEventListener("DOMContentLoaded", toggleHtvaLine);
  window.addEventListener("load", toggleHtvaLine);

  const target = document.getElementById("oo-tax-exemption");
  if (target) {
    const obs = new MutationObserver(toggleHtvaLine);
    obs.observe(target, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }

  /* -------------------------------------------------------
   * 5) Sécurité visuelle : texte sticky caché
   * ----------------------------------------------------- */

  const style = document.createElement("style");
  style.textContent = `
    modal-maxdesign button.cmd-btn__sticky span[hidden],
    modal-maxdesign button.cmd-btn--sticky span[hidden] {
      display: inline !important;
      visibility: visible !important;
    }
  `;
  document.head.appendChild(style);
})();